<div class="col-md-12 indent-top-sm">
    <div class="row page-title">Placeholder for TTC - Not yet implemented</div>
</div>